<div mat-dialog-title class="gwc-dialog-header">Change Password</div>
<mat-dialog-content class="dialog-form">
  <form class="flex flex-col gap-2" [formGroup]="form" (ngSubmit)="submit()">
    <label class="form-field-label" for="current-password">Current password</label>
    <mat-form-field>
      <input id="current-password" matInput type="password" formControlName="current_password" autocomplete="current-password">
      @if (form.controls.current_password.hasError('required')) { <mat-error>Current password is required.</mat-error> }
    </mat-form-field>
    <label class="form-field-label" for="new-password">New password</label>
    <mat-form-field>
      <input id="new-password" matInput type="password" formControlName="password" autocomplete="new-password">
      @if (form.controls.password.hasError('minlength')) { <mat-error>Use at least 12 characters.</mat-error> }
      @if (form.controls.password.hasError('required')) { <mat-error>New password is required.</mat-error> }
    </mat-form-field>
    <label class="form-field-label" for="confirm-new-password">Confirm new password</label>
    <mat-form-field>
      <input id="confirm-new-password" matInput type="password" formControlName="password_confirmation" autocomplete="new-password">
      @if (form.controls.password_confirmation.hasError('required')) { <mat-error>Please confirm the new password.</mat-error> }
    </mat-form-field>
    @if (serverError) { <div class="text-red-600">{{ serverError }}</div> }
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="isSaving">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="isSaving" (click)="submit()">{{ isSaving ? 'Saving…' : 'Change Password' }}</button>
</mat-dialog-actions>
